import React,{useState} from 'react'
import { Navbar, Container, Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import './NavbarMenu.css';
const NavbarMenu = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <div>
    <Navbar expand="lg"  className="navbarmenu">
      <Container>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={handleClick}><i className={click ? 'fas fa-times' : 'fas fa-bars' } style={{color:'#299AEF',transform:'Scale(1.3)'}}/></Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav >
            <Nav.Link as={Link} to='/'  >Home</Nav.Link>
            <Nav.Link as={Link} to='/About-School'>About School</Nav.Link>
            <Nav.Link as={Link} to='/Faculty'>Faculty</Nav.Link>
            <Nav.Link as={Link} to='/syllabus'>Syllabus</Nav.Link>
     
            <Nav.Link as={Link} to='/Gallery'>Gallery</Nav.Link>
            {/* <Nav.Link as={Link} to='/'>Achivement</Nav.Link> */}
  
            <Nav.Link as={Link} to='/Contact-Us'>Contact Us</Nav.Link>
            <Nav.Link as={Link} to='/notification'>Notice</Nav.Link>
            <Nav.Link href='https://eps.eshiksa.net/esh/index.php?plugin=Login&action=index'>Fees Payment</Nav.Link>


          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
  )
}

export default NavbarMenu